import {
    FormControl,
    FormControlProps,
    InputLabel,
    InputLabelProps,
    InputProps,
    MenuItem,
    Select,
    SelectProps,
    Skeleton,
} from '@mui/material';
import React, { forwardRef } from 'react'
import { colours } from '../StyleConstants'
interface Props {
    label?: string
    LabelProps?: InputLabelProps,
    isLoading?: boolean
    options?: { value: any, label: any }[]
    error?: boolean
    FormControlProps?: FormControlProps
  InputProps?: InputProps
}

const MenuProps = {
    autoFocus: false,
    PaperProps: {
        style: {
            maxHeight: "200px",
            OverflowY: "scroll"
        }
    }
};

const LassoSelect = forwardRef(function LassoSelect(props: SelectProps & Props, ref) {
    const { sx: selectSx, label = "", LabelProps = {}, defaultValue = "", ...selectProps } = props;
    const { sx: labelSx, ...labelProps } = LabelProps;
    return (
        <FormControl
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            error={props.error}
            {...props.FormControlProps}
        >
            <InputLabel
                shrink={true}
                sx={{
                    top: '-0.5rem',
                    transform: "translate(8px, -9px) scale(0.75)",
                    ...labelSx,
                }}
                {...labelProps}
            >
                {label}
            </InputLabel>
            <Select
                sx={{
                    background: colours.core.white,
                    height: "40px",
                    boxShadow: "1px 2px 5px 0px rgba(21, 24, 24, 0.10)",
                    "& fieldset": { border: 'none' },
                    "& .Mui-disabled": { backgroundColor: colours.gray.gray10 },
                    "&.Mui-focused": {
                        border: "2px solid #80B7F8",
                    },
                    ...selectSx
                }}
                {...selectProps}
                defaultValue={defaultValue}
                MenuProps={MenuProps}
                startAdornment={props.isLoading ? <Skeleton width={"100%"} /> : null}
                ref={ref}
                inputProps={props?.inputProps}
            >
                {props?.options?.map(({ value, label }) =>
                    <MenuItem key={value} value={value}>{label}</MenuItem>
                )}
            </Select>
        </FormControl>
    )
})
export default LassoSelect